import { render, staticRenderFns } from "./ProfileHome.vue?vue&type=template&id=4947950f&scoped=true"
import script from "./ProfileHome.vue?vue&type=script&lang=js"
export * from "./ProfileHome.vue?vue&type=script&lang=js"
import style0 from "./ProfileHome.vue?vue&type=style&index=0&id=4947950f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4947950f",
  null
  
)

export default component.exports